import { z } from 'zod';
import isBase64 from 'validator/lib/isBase64';
export const userRequestUpdateSchema = z.object({
    id: z.string(),
    email: z.string().min(1, 'too short').email('Invalid email'),
    password: z.string().min(5, 'too short'),
});
export const userRequestCreateSchema = z.object({
    email: z.string().min(1, 'too short').email('Invalid email'),
    password: z.string().min(5, 'too short'),
    timeZone: z.string(),
});
export const userRequestPasswordSchema = z.object({
    id: z.string(),
    password: z.string().min(5, 'too short'),
    newPassword: z.string().min(5, 'too short'),
});
export const userRequestForgotPasswordSchema = z.object({
    email: z.string().min(1, 'too short').email('Invalid email'),
});
export const userRequestResetPasswordSchema = z.object({
    token: z.string(),
    password: z.string().min(5, 'too short'),
});
export const userRequestSimpleFinSchema = z.object({
    token: z.string().refine((val) => isBase64(val), {
        message: 'Invalid base64 token',
    }),
});
export const userRequestTimeZoneSchema = z.object({
    timeZone: z.string(),
});
